import { render, staticRenderFns } from "./EmailVerificationCode.vue?vue&type=template&id=0df653e6&"
import script from "./EmailVerificationCode.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationCode.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerificationCode.vue?vue&type=style&index=0&id=0df653e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports